var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"study"},[_c('div',{staticClass:"study-play"},[_c('examine')],1)]),_vm._v(" "),_c('test'),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-play"},[_c('particular-year')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0d7cfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test/examination.vue
// module id = null
// module chunks = 